var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.335,
    height: 65.326,
    viewBox: "0 0 65.335 65.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_011-house",
    "data-name": "011-house",
    d: "M50.022,65.363H15.313A15.33,15.33,0,0,1,0,50.05V28.577A15.4,15.4,0,0,1,6.026,16.4L23.381,3.165a15.35,15.35,0,0,1,18.573,0l5.516,4.2V4.111a2.552,2.552,0,0,1,5.1,0v8.411a2.552,2.552,0,0,1-4.1,2.03L38.859,7.224a10.234,10.234,0,0,0-12.383,0L9.122,20.46A10.267,10.267,0,0,0,5.1,28.577V50.05A10.22,10.22,0,0,0,15.313,60.259H50.022A10.22,10.22,0,0,0,60.231,50.05V28.577a10.274,10.274,0,0,0-3.972-8.145,2.552,2.552,0,1,1,3.1-4.058,15.407,15.407,0,0,1,5.981,12.2V50.05A15.33,15.33,0,0,1,50.022,65.363ZM27.563,29.505a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,27.563,29.505Zm13.4,3.19a3.19,3.19,0,0,1-6.38,0A3.19,3.19,0,0,1,40.962,32.7ZM30.753,42.9a3.19,3.19,0,0,1-6.38,0A3.19,3.19,0,0,1,30.753,42.9Zm10.209,0a3.19,3.19,0,0,1-6.38,0A3.19,3.19,0,0,1,40.962,42.9Z",
    transform: "translate(0 -0.037)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.16c1bbca2493249fe1525607867f486a.svg";
export { ForwardRef as ReactComponent };